import { ClassType } from 'types/cover';
import { Risk } from 'types/policy';

export interface PremiumClassTypes {
  classType: ClassType;
  amount: number;
}
/**
 * @description
 * Transform premium risk types array
 */
export const getPremiumClasses = (risks: Risk[]): PremiumClassTypes[] | [] => {
  if (risks.every((risk) => !risk.premium)) throw new Error('Missing premium in risk');

  return risks
    .map((risk) =>
      risk
        .premium!.premiumClass.filter((pc) => pc.classType !== ('TOT' as ClassType))
        .map((pc) => ({
          classType: pc.classType,
          amount: pc.transactionPremium.premium as number,
        }))
    )
    .flat();
};
